import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { useUserContext } from '../hooks/auth/UserProvider';
import { isNationalEntityUser } from '../helpers/authorizedUser';

interface NationalEntityRouteProps {
	children: ReactNode;
}

const NationalEntityRoute: React.FC<NationalEntityRouteProps> = ({ children }) => {
	const auth = useAuth();
	const { user } = useUserContext();

	if (auth.isLoading) {
		return null;
	}

	if (auth.isAuthenticated && user === undefined) {
		return null;
	}

	if (!isNationalEntityUser(user)) {
		return <Navigate to="/404" replace />;
	}

	return <>{children}</>;
};

export default NationalEntityRoute;
